import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Box } from 'grid-styled'
import { fetchRechargeValues, fetchAccountPlans } from 'alelo-logic/actions'

import { RouteWithSubRoutes } from '../../../routes'

import Icon from '../../elements/Icon/Icon'
import Content from '../../../styles/objects/Content'
import rem from '../../../styles/tools/rem'

import { Header, HeaderContainer, HeaderLink, Container } from './styles'

import { backCopy, backCopyDados } from './data.json'

class TemplateRecharge extends Component {
  state = {}

  componentWillMount() {
    this.props
      .fetchRechargeValues(this.props.match.params.id)
      .then(() => this.props.getAccountPlans())
  }

  render() {
    const { routes, match, location: { search } } = this.props
    const templateType =
      (routes[0].path === '/minha-veloe/:id/editar-dados') &
      (search !== '?path=recharge') &
      (search !== '?path=track')
        ? 'dados-do-plano'
        : 'resumo'

    const textLinkBack =
      templateType === 'dados-do-plano' && search !== '?path=recharge' ? backCopyDados : backCopy
    return (
      <Container>
        <Header>
          <HeaderContainer>
            <HeaderLink id="hypBackSummary" to={`/minha-veloe/${match.params.id}/${templateType}`}>
              <Icon icon="back-arrow" width="10px" height="15px" viewBox="0 0 10 15" />
              <span>{textLinkBack}</span>
            </HeaderLink>
          </HeaderContainer>
        </Header>
        <Box my={rem('45px')}>
          <Content>
            {routes.map(route => <RouteWithSubRoutes key={route.path} {...route} />)}
          </Content>
        </Box>
      </Container>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  getAccountPlans: () => dispatch(fetchAccountPlans()),
  fetchRechargeValues: planId => dispatch(fetchRechargeValues(planId))
})

export default connect(null, mapDispatchToProps)(TemplateRecharge)



// WEBPACK FOOTER //
// ./src/app/templates/TemplateRecharge/index.js